import { Container } from '../../components/container/container';
import { Page } from '../../components/page-layout/page';
import { createFileRoute } from '../../utils/route-factory';

function RouteComponent() {
  return (
    <Page
      title='Intake Form'
      breadcrumbs={[
        {
          label: 'Onboarding',
        },
        {
          label: 'Intake Form',
        },
      ]}
    >
      <Container>TODO</Container>
    </Page>
  );
}

export const Route = createFileRoute({
  path: '/onboarding/intake-form',
  component: RouteComponent,
  type: 'auth',
});
